import { FadeIn } from "../components/FadeIn";
import { ProjectCard } from "../components/ProjectCard";
import { projects } from "../content/portfolio";

export function ProjectsSection() {
  return (
    <section id="projects" aria-labelledby="projects-heading" className="projects-section">
      <div className="projects-heading-row">
        <FadeIn as="h2" id="projects-heading" y={34} className="section-heading section-heading--dark">
          项目经历
        </FadeIn>
        <FadeIn as="p" delay={0.1} className="projects-lede">
          四个项目，四种验证场景。每一张案例档案都把背景、职责、方案和证据放在同一条链路上。
        </FadeIn>
      </div>

      <div className="projects-stack">
        {projects.map((project, index) => (
          <ProjectCard key={project.slug} project={project} index={index} totalCards={projects.length} />
        ))}
      </div>
    </section>
  );
}
